import { render, staticRenderFns } from "./outPage.vue?vue&type=template&id=2654967e&"
import script from "./outPage.vue?vue&type=script&lang=ts&"
export * from "./outPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports